const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the workflow list
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('workflowUsersList', ['Users', 'Categories', '$q', '$translate', function (Users, Categories, $q, $translate) {
  return {
    restrict: 'E',
    scope: {
      list: '=',
      dynamicMessage: '@'
    },
    template: require('../../templates/directives/workflow-users-list.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.queryIds = {};
      self.queries = [];
      self.departments = {};
      self.locations = {};
      self.translations = {};

      // ------------- start ngTag triggered actions ------------
      self.addingTag = function($tag) {
        $tag.type = $tag.type || 'text';
        for (var i = 0; i < self.queries.length; i++) {
          if (self.queries[i].type === $tag.type) {
            self.queries.splice(i, 1);
            break;
          }
        }
        return true;
      };

      self.addedTag = function($tag) {
        self.queryIds[$tag._id] = true;
        self.navigation.updateQuery(true);
      };

      self.removedTag = function($tag) {
        self.queryIds[$tag._id] = false;
        self.navigation.updateQuery(true);
      };

      self.removeTags = function() {
        self.queries = [];
        self.queryIds = {};
        self.navigation.updateQuery(true);
      };
      // ------------- End ngTag triggered actions ------------


      var legacyName = function(item, type) {
        var name = '';
        var parent;
        var parentName;
        var papa;
        var papaName;

        item.legacyName = item.name;

        if (item.parent) {
          parent = self[type][item.parent];
          parentName = parent.name + ' -> ';
          papa = parent.parent;
          item.legacyName = parentName + item.name;
        }

        if (papa) {
          papa = self[type][papa];
          papaName = papa.name + ' -> ';
          item.legacyName = papaName + parentName + item.name;
        }
      };

      self.sortCategories = function(data) {
        angular.forEach(data, function(cat) {
          if (cat.location) {
            self.locations[cat._id] = cat;
          }
          if (cat.department) {
            self.departments[cat._id] = cat;
          }
        });
        for (var loc in self.locations) {
          legacyName(self.locations[loc], 'locations');
        }
        for (var dep in self.departments) {
          legacyName(self.departments[dep], 'departments');
        }
      };

      self.getOptions = function(input) {
        var deferred = $q.defer();

        input = input ? input.toLowerCase() : '';
        var usersPlaceholder = {name: 'Users', text: self.translations['global.label.users'], _id: 'users', placeholder: true};
        var locationsPlaceholder = {name: 'Locations', text: self.translations['global.label.locations'], _id: 'locations', placeholder: true};
        var departmentsPlaceholder = {name: 'Departments', text: self.translations['global.label.departments'], _id: 'departments', placeholder: true};
        var addedItems = {
          users: false,
          locations: false,
          departments: false
        };

        var query = {
          page: 1,
          per_page: 6,
          fields: '_id,first_name,last_name,email,full_name,role,image,department,office_location,last_login,linked_departments',
          full_name: '$regex,2,' + input + ',i',
          sort: 'full_name,-1'
        };

        Users.findFromSet(query, {users: $scope.list}).$promise
        .then(function(users) {
          var items = [];

          // Add users to options
          for (var i = 0; i < users.length; i++) {
            if (!self.queryIds[users[i]._id]) {
              if (!addedItems.users) {
                items.push(usersPlaceholder);
                addedItems.users = true;
              }

              items.push({
                name: users[i].full_name,
                first_name: users[i].first_name,
                last_name: users[i].last_name,
                text: users[i].full_name,
                image: users[i].image,
                _id: users[i]._id,
                type: 'user'
              });
            }
          }

          // Add locations to options
          for (var loc in self.locations) {
            if (new RegExp(input).test(self.locations[loc].name.toLowerCase()) && !self.queryIds[self.locations[loc]._id]) {
              if (!addedItems.locations) {
                items.push(locationsPlaceholder);
                addedItems.locations = true;
              }
              items.push({
                name: self.locations[loc].name,
                text: self.locations[loc].legacyName,
                _id: self.locations[loc]._id,
                type: 'location'
              });
            }
          }
          for (var dep in self.departments) {
            if (new RegExp(input).test(self.departments[dep].name.toLowerCase()) && !self.queryIds[self.departments[dep]._id]) {
              if (!addedItems.departments) {
                items.push(departmentsPlaceholder);
                addedItems.departments = true;
              }
              items.push({
                name: self.departments[dep].name,
                text: self.departments[dep].legacyName,
                _id: self.departments[dep]._id,
                type: 'department'
              });
            }
          }

          deferred.resolve(items);
        });

        return deferred.promise;
      };

      self.navigation = {
        page: 1,
        per_page: 15,
        active: [],
        next: function() {
          if (this.active.length < this.per_page) {
            return;
          }
          this.page++;
          this.updateQuery();
        },
        previous: function() {
          if (this.page <= 1) {
            return;
          }
          this.page--;
          this.updateQuery();
        },
        textQuery: function(text) {
          return '15,full_name,$regex,2,' + text + ',i,job_title,$regex,2,' + text + ',i,email,$regex,2,' + text + ',i';
        },
        updateQuery: function(refreshed, checkSuspended) {
          self.loading = true;
          self.navigation.active = [];
          self.suspendedCount = null;
          if (refreshed) {
            this.page = 1;
          }
          var query = {
            fields: '_id,first_name,last_name,email,full_name,role,image,department,office_location,last_login,linked_locations,linked_departments',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            page: this.page,
            per_page: this.per_page,
            sort: 'full_name,-1'
          };
          for (var i = 0; i < self.queries.length; i++) {
            if (self.queries[i].type === 'text') {
              query['$or'] = this.textQuery(self.queries[i].name);
            }
            if (self.queries[i].type === 'department') {
              var deps = this.getLineage(self.queries[i]._id, 'departments');
              query.linked_departments = '$in,' + deps.length + ',' + deps.join(',');
            }
            if (self.queries[i].type === 'location') {
              var locs = this.getLineage(self.queries[i]._id, 'locations');
              query.linked_locations = '$in,' + locs.length + ',' + locs.join(',');
            }
          }

          var userids = [];
          for (var item in self.queryIds) {
            if (!item || !self.queryIds[item] || $scope.list.indexOf(item) === -1) {
              continue;
            }

            userids.push(item);
          }

          var goList = $scope.list;
          if (userids.length) {
            goList = userids;
          }

          Users.findFromSet(query, {users: goList})
          .$promise.then(function(users) {
            self.navigation.active = users;
            if (checkSuspended) {
              if (users.length < self.navigation.per_page && $scope.list.length > users.length) {
                self.suspendedCount = $scope.list.length - users.length;
              }
            }
            self.loading = false;
          });
        },
        getLineage: function(id, type) {
          var items = [id];
          var children = [];
          var grandChildren = [];

          var addTo = function(id) {
            children.push(id);
            var main = self[type][id];
            if (!main || !main.children || !main.children.length) {
              return;
            }
            for (var i = 0; i < main.children.length; i++) {
              grandChildren.push(main.children[i]);
            }
          };

          if (!self[type][id] || !self[type][id].children || !self[type][id].children.length) {
            return items;
          }

          for (var i = 0; i < self[type][id].children.length; i++) {
            addTo(self[type][id].children[i], children);
          }

          return items.concat(children, grandChildren);
        }
      };
      var initialized = false;
      self.initialize = function() {
        if (initialized) {
          self.navigation.updateQuery(true, true);
          return;
        }
        Categories.find({
          $or: '4,location,true,department,true',
          sort: 'name,1'
        }).$promise
        .then(function(data) {
          initialized = true;
          self.sortCategories(data);
          self.navigation.updateQuery(true, true);
        });
        self.listcount = $scope.list.length;
      };

      if ($scope.list && $scope.list.length) {
        self.initialize();
      }

      $scope.$watch('list', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.initialize();
          self.listcount = $scope.list.length;
        }
      });

      $translate([
        'global.label.users',
        'global.label.locations',
        'global.label.departments'
      ]).then(function (translations) {
        self.translations = translations;
      });

    }],
    controllerAs: 'search'
  }
}]);